import React from 'react';
import {NavLink} from 'react-router-dom';

const DashboardCard = ({ title, icon, children, action, className = '' }) => {
    return (
        <div className={`home-component d-flex flex-column p-3 m-3 w-100 h-100 bg-broken border-start border-primary ${className}`}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h2 className="text-capitalize m-0 text-light fs-5">
                    {icon && <span className={`${icon} me-2 text-primary`} />}
                    {title}
                </h2>
            </div>

            <div className="mb-3 flex-grow-1">
                {children}
            </div>

            {action && (
                <div className="mt-auto">
                    <NavLink to={action.to} className="text-decoration-none text-primary">
                        {action.label} <span className="fas fa-arrow-right ms-2" />
                    </NavLink>
                </div>
            )}
        </div>
    );
};

export default DashboardCard;
